// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-AgU","top":"styles_top__FkfGk","left":"styles_left__1jBQU","description":"styles_description__22eLS"};